export function parseRunningHours(value: string): number | null {
  if (!/^\d+$/.test(value.trim())) return null;
  const hours = Number(value.trim());
  return Number.isInteger(hours) && hours >= 0 && hours <= 2147483647 ? hours : null;
}
